require('./bootstrap');

import './repeater/init'

window.AgGrid = require('ag-grid-community')
window.moment = require('moment')

